import React from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm, ILeaveToRemain } from '../../../../../types';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';
import { Box } from '@chakra-ui/react';
import { useTranslation } from "react-i18next";

function VisaPrepAdditionalHistoryStep5Info(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  const renderLeaveToRemains = () => {
    const allLeaveToRemains: React.ReactNode[] = [];
    if (props.leaveToRemains && props.leaveToRemains.length) {
      props.leaveToRemains.forEach((leaveToRemain: ILeaveToRemain, i: number) => {
        allLeaveToRemains.push(
          <SummaryGroup title={t('forms.visa:leaveApplication', { i: i + 1 })} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.LEAVE_TO_REMAIN_DATE}-${i}`}
              label={t('forms.visa:dateOfApplication')}
              value={leaveToRemain.applicationDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.LEAVE_TO_REMAIN_TYPE}-${i}`}
              value={leaveToRemain.applicationType}
              label={t('forms.visa:typeOfApplication')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.LEAVE_TO_REMAIN_REFERENCE}-${i}`}
              value={leaveToRemain.reference}
              label={t('forms.visa:homeOfficeReferenceNumber')}
            />
          </SummaryGroup>,
        );
      });
    }
    return allLeaveToRemains;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        label={t('forms.visa:howManyTimesDidYouApplyForLeaveT')}
        value={props.leaveToRemains?.length}
      />

      <Box as="ol" pl={8} key={'leave-to-remains'}>
        {renderLeaveToRemains()}
      </Box>
    </>
  );
}

export default VisaPrepAdditionalHistoryStep5Info;
